"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViciousClawsAbilityHandler = exports.ViciousClawsActorAbilityFactory = exports.ViciousClawsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const IdArray_1 = require("../../core/utils/IdArray");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ViciousClawsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ViciousClaws;
        this.__typeName = "ViciousClaws";
    }
}
exports.ViciousClawsAbilityArgs = ViciousClawsAbilityArgs;
let ViciousClawsActorAbilityFactory = class ViciousClawsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ViciousClaws", "AllEnemies", 2);
    }
};
ViciousClawsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ViciousClaws")
], ViciousClawsActorAbilityFactory);
exports.ViciousClawsActorAbilityFactory = ViciousClawsActorAbilityFactory;
let ViciousClawsAbilityHandler = class ViciousClawsAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = (0, IdArray_1.shuffle)(container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies))
            .slice(0, (0, Random_1.random)(1, 2))
            .flatMap((targetId) => [
            targetId,
            (0, Random_1.random)(1, 100) <= 50 && targetId
        ])
            .filter(Boolean);
        const sequenceByTargetId = new Map();
        let hits = 0;
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: "ViciousClaws",
            attackType: "melee",
            targets: targets.map(targetId => ({
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 110)
                ],
                targetId
            })),
            onHit: (sequence, target) => {
                hits += 1;
                sequenceByTargetId.set(target.targetId, sequence);
            }
        });
        const bleeds = Array(hits).fill(0)
            .map(() => new core_1.BleedingEffectArgs("Power", 10));
        Array.from(sequenceByTargetId.keys())
            .forEach(targetId => {
            container.applyDebuffs({
                attackerId: ability.invokerId,
                targetId,
                effects: bleeds.map(effect => ({
                    duration: Duration_1.Duration.Turns(2),
                    effect
                })),
                sequence: sequenceByTargetId.get(targetId)
            });
        });
    }
};
ViciousClawsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ViciousClaws)
], ViciousClawsAbilityHandler);
exports.ViciousClawsAbilityHandler = ViciousClawsAbilityHandler;
